import { motion } from 'framer-motion'

interface UploadingOverlayProps {
  primaryColor: string
}

/**
 * Wave 7a: Full-screen blocking overlay shown while session audio is being
 * finalized & uploaded. Pure presentational — no state, no callbacks.
 */
export const UploadingOverlay = ({ primaryColor }: UploadingOverlayProps) => (
  <motion.div
    key="uploading-overlay"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      zIndex: 10002,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
    }}
  >
    <motion.div
      animate={{ rotate: 360 }}
      transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
      style={{
        width: 48,
        height: 48,
        border: '4px solid rgba(255, 255, 255, 0.3)',
        borderTopColor: primaryColor,
        borderRadius: '50%',
      }}
    />
    <div style={{ color: 'white', fontSize: 18, fontWeight: 500, textAlign: 'center' }}>
      מעדכן ומסיים...
    </div>
    <div style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: 14, textAlign: 'center' }}>
      Updating...
    </div>
  </motion.div>
)
